import { importLibrary, setOptions } from "@googlemaps/js-api-loader"

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  setOptions({
    key: config.public.GOOGLE_API_KEY,
    v: "weekly",
  })

  const googleApiPromise: Promise<typeof google> = Promise.all([
    importLibrary("maps"),
    importLibrary("marker"),
    importLibrary("places"),
  ]).then(() => window.google)

  return {
    provide: {
      googleApiPromise,
    },
  }
})
